import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=2ed6a14a&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=2ed6a14a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6a14a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed6a14a')) {
      api.createRecord('2ed6a14a', component.options)
    } else {
      api.reload('2ed6a14a', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=2ed6a14a&scoped=true", function () {
      api.rerender('2ed6a14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programTask/components/tableData.vue"
export default component.exports